export const updateDatiModPagReimpiego = (unDato, unActionType) => {
  return {
    type: unActionType,
    unDato,
  }
};